export default "__VITE_ASSET__CMGu4bv5__"